// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Caml_option = require("rescript/lib/js/caml_option.js");
var ImageGallery = require("../../common/Components/ImageGallery.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var PropertyWizardRelayPreviewImageGrid_displayHelpers_graphql = require("../../../__generated__/PropertyWizardRelayPreviewImageGrid_displayHelpers_graphql.bs.js");

var convertFragment = PropertyWizardRelayPreviewImageGrid_displayHelpers_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayPreviewImageGrid_displayHelpers_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayPreviewImageGrid_displayHelpers_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, PropertyWizardRelayPreviewImageGrid_displayHelpers_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayPreviewImageGrid_displayHelpers_graphql.node, convertFragment, fRef);
}

var DisplayHelpersFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function PropertyWizardRelay__Preview__ImageGrid(props) {
  var displayHelpers = use(props.displayHelpers);
  var images = displayHelpers.images;
  var images$1 = images !== undefined ? images.map(function (img) {
          return img.fragmentRefs;
        }) : [];
  return JsxRuntime.jsx(ImageGallery.make, {
              images: images$1
            });
}

var MissingFieldMarker;

var Validators;

var make = PropertyWizardRelay__Preview__ImageGrid;

exports.MissingFieldMarker = MissingFieldMarker;
exports.Validators = Validators;
exports.DisplayHelpersFragment = DisplayHelpersFragment;
exports.make = make;
/* ImageGallery Not a pure module */
